// extracted by mini-css-extract-plugin
export var statItem = "_iy-1";
export var statsRow = "_iy-0";